import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Optional, Output } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import {select, Store} from '@ngrx/store';

import { selectCurrentTreatment } from 'libs/treatments/src/lib/store/treatment.selectors';
import { TreatmentRequested } from 'libs/treatments/src/lib/store/treatment.actions';
import { selectUser } from 'libs/auth/src/lib/store/auth.selectors';
import { selectShippingAddresses } from 'libs/customer/src/lib/store/customer.selectors';
import { AppState } from 'libs/tm-common/src/lib/store/reducers/reducers';
import { NotificationService } from 'libs/tm-common/src/lib/services/notification.service';
import { ACTION } from 'libs/tm-common/src/lib/constants/subcomponent.actions';
import { UpsPickupContext, UpsPickupReference } from 'libs/tm-common/src/lib/models/ups.model';
import { TreatmentsService } from 'libs/treatments/src/lib/services/treatments.service';

@Component({
	selector: 'ux-pickup-container',
	templateUrl: './ups-pickup-container.component.html',
	styleUrls: ['./ups-pickup-container.component.scss']
})
export class UpsPickupContainerComponent implements OnInit {

	@Output() action = new EventEmitter<any>();
	@Input() wmsId: string;
	@Input() treatmentId; // treatmentId

	shippingAddresses$ = this.store.pipe( select (selectShippingAddresses) );
	user$ = this.store.pipe( select(selectUser) );
	treatment$ = this.store.pipe( select(selectCurrentTreatment) );

	customerContext: UpsPickupContext = {
		CustomerContext: 'wmsId(n/a),treatmentId(n/a)'
	};
	prn = null;

	loading = false;

	constructor(
		public store: Store<AppState>,
		private notification: NotificationService,
		private treatmentService: TreatmentsService,
		@Optional() @Inject(MAT_DIALOG_DATA) data: { customerWmsId: string; treatmentId: string; }) {
		if (data) {
			this.wmsId = data.customerWmsId;
			this.treatmentId = data.treatmentId;
		}
	}

	ngOnInit() {
		// initialize CustomerContext
		this.customerContext.CustomerContext = this.wmsId + ',' + `${this.treatmentId}`.substring(0, 8);
	}

	onAction(action) {
		switch (action.type) {
			case ACTION.SUBMIT:
				this.orderPickupService(action.payload, this.customerContext);
				break;
			default:
				break;
		}
	}

	orderPickupService(payload: Partial<UpsPickupReference>, context: UpsPickupContext) {
		this.loading = true;
		this.treatmentService
			.createUpsPickupRequest(this.treatmentId, payload.address, payload.dateTime, context, payload.specialInstruction)
			.subscribe({
				next: (response: UpsPickupReference) => {
					this.loading = false;
					this.prn = response.prn;
					this.store.dispatch(new TreatmentRequested({id: this.treatmentId}));
					this.action.emit({type: ACTION.ENABLE_NEXT, payload: 'Next'});
				},
				error: () => {
					this.loading = false;
					this.notification.showErrorMessage("UPS.pickupRequestError", "", 5000);
				}
			});
	}

}
